import React, { Component } from 'react';
import ScrollToTopOnMount from '../scroll_top';
import { confirmAlert } from 'react-confirm-alert';
import _ from "lodash";

export default class FoliosTable extends Component {

	render() {
		const { documento, projects, entities } = this.props;
		const { modality } = this.props.match.params;
		let pc = _.find(projects.permissions, (o) => { return o === 'Create' });
		return (

			<div className="columns is-centered">
				<div className="column is-10">
					{this.state.documentEditForm &&
						<DocumentEditForm
							document_index={this.state.document_index}
							active={this.state.documentEditForm}
							closeModal={() => this._toggleModal()}
							version={this.state.version}
							modalidad={this.state.modalidad}
							documento={this.state.documento}
							{...this.props}
						/>
					}

					<ScrollToTopOnMount {...this.props} />
					<h5 className="title is-5">Folios de proyectos{modality === 'modalidad-i' ? ' - Modalidad I' : (modality === 'modalidad-ii' ? ' - Modalidad II' : ' - Modalidad III')}</h5>
					{!_.isEmpty(projects.folios) ?
						<table className="is-fullwidth table project-goal-table no-margin">
							<tbody>
								{_.map(projects.folios, (item, k) => {
									let stateInfo = undefined;
									if (modality === 'modalidad-ii' && item.agency && item.agency && item.agency.agenciable) {
										stateInfo = _.find(entities.list, { id: item.agency.agenciable.state_id });
									}
									return [
										<tr key={`instance-${k}`}>
											<td className="goal-cell" style={{ width: '10%' }}>
												<span className="help is-white">Folio</span>
												<strong>{item.code ? item.code : '---'}</strong>
											</td>
											<td className="goal-cell" style={{ width: '70%' }}>
												<span className="help is-white">Instancia</span>
												<strong>{item.agency && item.agency.name ? item.agency.name : '---'}</strong>
											</td>
											<td className="goal-cell">
												<span className="help is-white">Estado</span>
												{modality !== 'modalidad-ii' ?
													<strong>{item.agency && item.agency && item.agency.agenciable ? item.agency.agenciable.name : '---'}</strong>
													: <strong>{stateInfo ? stateInfo.name : '---'}</strong>}
												{modality === 'modalidad-ii' ? <span className="help is-white">Municipio</span> : ''}
												{modality === 'modalidad-ii' ? <strong>{item.agency && item.agency && item.agency.agenciable ? item.agency.agenciable.name : '---'}</strong> : ''}
											</td>
										</tr>,
										<tr key={`general-${k}`}>
											<td colSpan={2}>
												<span className="help is-dark"><strong>Titular:   </strong>
													{item.agency && item.agency && item.agency.owner ?
														`${item.agency.owner.title} ${item.agency.owner.name} 
											${item.agency.owner.last_name} 
											${item.agency.owner.slast_name}`
														: '---'}
												</span>

												<span className="help is-dark">
													<strong>Documentos Faltantes:   </strong>
													{item.docuentos != null ? item.docuentos :
														'---'}
												</span>

												<span className="help is-dark">
													<strong>Notificación documentos completos del área Juridica </strong>
													{item.notificacion != null ? 'Sí' : 'No'}
												</span>
												<span className="help is-dark">
													<strong>Notas: </strong>
													{item.notas!=null?item.notas:'---'}
												</span>
											</td>
											<td >
												<div className="control">
													{item.finalizado != null && item.notificacion != null && item.code == null ?
														<button style={{ fontSize: '20px' }}
															className="button is-large is-inm-purple"
															onClick={() => this._asignarFolioManual(item.id, projects.version.id, item.modality_id)} >Asignar
														</button>
														: ''
													}
													{item.finalizado != null && item.notificacion != null && item.code != null ?
														<span className="help is-dark">
															<button type="button"  style={{fontSize: `13px`}} className="button is-large is-inm-purple" onClick={() => this._editDocument(item, projects.version.id, item.modality_id, k)}> Eliminar folio</button>


														</span>

														: ''}


												</div>

											</td>
										</tr>
									];
								})}
							</tbody>



						</table> : <p className="has-text-primary"><span className="icon has-text-danger"><i className="fa fa-lg fa-exclamation-triangle" /></span> Sin información <br /><br /></p>}

					<div className="columns ">
						<div className="column">
							<div className="field is-grouped is-grouped-right">
								<div className="control">
									<button className="button is-large" onClick={() => this.props.history.goBack()}>Regresar</button>
								</div>

								{pc ?
									<div className="control">


										<button className="button is-large is-inm-purple" onClick={() => this._handleClick()} disabled={_.isEmpty(projects.folios)}>Asignar Folios</button>
									</div> : ''}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}


	_handleClick(version) {
		let { modality } = this.props.match.params;
		this.props.projectsFoliosAssign(modality);
	}
	_asignarFolioManual(id, version, midality) {
		//	let { modality } = this.props.match.params;
		this.props.asignacionFoliosManual(id, version, midality);

	}

	_aquitarFoliosManual(id, version, midality) {
		//	let { modality } = this.props.match.params;
		confirmAlert({
			title: '¿Está seguro?',
			message: '¿Desea eliminar el folio?.',
			confirmLabel: 'Aceptar',
			cancelLabel: 'Cancelar',

			onConfirm: () => {

				this.props.aquitarFoliosManual(id, version, midality);
			}

		})
	}

	_toggleModal() {
		this.setState({
			document_index: undefined,
			documentEditForm: false,
			version: undefined,
			modalidad: undefined,
			documento: undefined

		});
		this.props.change('documento', {})

	}

	_editDocument(data, versionid, modalidadId, index) {
		this.props.change('documento', {
			...data
		})
		this.setState({
			document_index: index,
			documentEditForm: true,
			version: versionid,
			modalidad: modalidadId,
			documento: data
		})
	}

	constructor() {
		super();
		this.state = {
			document_index: undefined,
			documentEditForm: false,
			version: undefined,
			modalidad: undefined,
			documento: undefined
		}
	}

}

class DocumentEditForm extends Component {

	render() {
		const { documento, version, modalidad } = this.props;
		return (
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" onClick={this.props.closeModal} />
				<div className="modal-card" style={{ width: '20%' }}>
					<header className="modal-card-head">
						<p className="modal-card-title">Cancelar folio</p>
						<button type="button" onClick={this.props.closeModal} className="delete" aria-label="close" />
					</header>
					<div className="modal-card-body">
						<form onSubmit={(values) => this._aquitarFoliosManual()}>
							<div className="field is-grouped">
								<span className="small has-text-danger">¿Deseas eliminar el folio?</span>
							</div>
							<div className="field is-grouped">
								<div className="control is-expanded">
									<label htmlFor="name" className="label">Motivo de cancelación <span className="small has-text-danger">*</span></label>
									<input type="text" onChange={(value) => this.onBlurValidarActividades(value)} />
								</div>

							</div>
							<div className="field is-grouped">
								<div className="control">
									<button type="button" className="button" onClick={this.props.closeModal}>Cerrar</button>
								</div>
								<div className="control">
									<button type="button" className="button is-primary" onClick={e => {
										documento.notas = this.state.notas;
										this.props.aquitarFoliosManual(documento.id, documento.notas, version, modalidad);
									}}>
										Aceptar</button>
								</div>
							</div>
						</form>
					</div>

				</div>
			</div>

		)
	}
	onBlurValidarActividades(e) {
		var a = e.target.value;
		this.state.notas = e.target.value;
	
	}
	_aquitarFoliosManual() {
		console.log("_aquitarFoliosManual()...", this.state.notas);
	}

	handleChange(valor) {
		//	handleChange(event) {
		//this.setState({ value: event.target.value }); this.state.value
		console.log(valor);
	}

	/*
	<Control.text model=".notas" id="name" value={this.state.value} className="input" placeholder="Nombre del documento" />
	
	<Control.text model=".notas" id="name" value={this.state.value} className="input" placeholder="Nombre del documento" />
		*/
	_saveDocument(texto) {
		console.log("-------");
		console.log(texto);
	}

	_aquitarFoliosManual(id, version, midality) {
		//	let { modality } = this.props.match.params;
		/*	confirmAlert({
				title: '¿Está seguro?',
				message: '¿Desea eliminar el folio?.',
				confirmLabel: 'Aceptar',
				cancelLabel: 'Cancelar',
	
				onConfirm: () => {
	
					this.props.aquitarFoliosManual(id, version, midality);
				}
	
			})*/
	}

	constructor() {
		console.log("constructor----");
		super();
		this.state = {
			notas: ''

		}

	}

	componentWillMount() {
		const { documento } = this.props;
		console.log("componentWillMount *****----");
		this.setState({
			notas: ''
		})
		console.log(this.state.documento);
	}
}


// WEBPACK FOOTER //
// ./src/elements/projects/folios.jsx